function arrayObjectIndexOf(arr, val, prop){
  // returns -1 if property doesn't exist or index value if it does
  for(var i = 0, len = arr.length; i < len; i++) {
      if (arr[i][prop] === val) return i;
  }
  return -1;
}
function sortData (data, prop) {
    var myData = data
    .sort((a, b) => {
      
      if (a[prop] < b[prop]) {
        return -1;
      }
      if (a[prop] > b[prop]) {
        return 1;
      }
      return 0;
    })

    return myData;
}
function pad(n, p, c) {
  /*
  n = number
  p = how number char length
  c = char to pad with
  */
    var pad_char = typeof c !== 'undefined' ? c : '0';
    var pad = new Array(1 + p).join(pad_char);
    return (pad + n).slice(-pad.length);
}
const GeneralUtil = { arrayObjectIndexOf, sortData, pad };
export default GeneralUtil;


// WEBPACK FOOTER //
// ./src/utils/GeneralUtils.js